// Booking form constants
export const TIMEZONE = 'Europe/London';

export const TRIP_TYPES = [
    { id: 1, name: 'One Way', disabled: false },
    { id: 2, name: 'Return', disabled: false },
];

export const FORM_FIELD_NAMES = {
    PICKUP_ADDRESS: 'pickUpAddress',
    DROPOFF_ADDRESS: 'dropOffAddress',
    TRIP_TYPE: 'tripType',
    NO_OF_PASSENGERS: 'noOfPassengers',
    DEPARTURE_DATE: 'departureDate',
    DEPARTURE_TIME: 'departureTime',
    RETURN_DATE: 'returnDate',
    RETURN_TIME: 'returnTime',
    PICKUP_LAT: 'pickupLat',
    PICKUP_LONG: 'pickupLong',
    DROPOFF_LAT: 'dropOffLat',
    DROPOFF_LONG: 'dropOffLong',
};

export const INITIAL_FORM_DATA = {
    pickUpAddress: '',
    dropOffAddress: '',
    pickUp: 0,
    dropOff: 0,
    tripType: '2',
    noOfPassengers: '',
    departureDate: '',
    departureTime: '',
    departureUnix: '',
    returnDate: '',
    returnTime: '',
    returnUnix: '',
    gclid: '',
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_term: '',
    utm_content: '',
    // Location coordinates
    pickupLat: null,
    pickupLong: null,
    dropOffLat: null,
    dropOffLong: null,
    distance: null,
    // Form source tracking
    formSource: '', // URL path where form was filled (e.g., "/", "/airport-transfers", "/airport-transfers/london")
};
